module.exports = __webpack_public_path__ + "static/media/first-page-slide3.8825d09e.jpg";